module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notes":"Notes","viewMoreDetails":"view more details","submittedForm":"Submitted Form"},"es":{"notes":"Notas","viewMoreDetails":"ver más detalles","submittedForm":"Formulario Enviado"},"sw":{"notes":"Maelezo","viewMoreDetails":"view more details","submittedForm":"Fomu Iliyowasilishwa"}}')
  delete Component.options._Ctor
}
